import React, { useState, useEffect } from 'react';
import { getMyAnnouncements } from '../../api';
import { toast } from 'react-toastify';

const StudentAnnouncements = () => {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => { loadAnnouncements(); }, []);

  const loadAnnouncements = async () => {
    try {
      const res = await getMyAnnouncements();
      setAnnouncements(res.data);
    } catch (err) {
      toast.error('Error loading announcements');
    }
  };

  const typeColors = {
    test: { bg: '#f8d7da', color: '#721c24', icon: '📝' },
    syllabus: { bg: '#cce5ff', color: '#004085', icon: '📚' },
    assignment: { bg: '#fff3cd', color: '#856404', icon: '📋' },
    general: { bg: '#d4edda', color: '#155724', icon: '📢' },
  };

  return (
    <div>
      <h3 style={styles.title}>📢 Announcements</h3>

      {announcements.length === 0 && (
        <div style={styles.empty}>No announcements yet!</div>
      )}

      {announcements.map(a => {
        const typeInfo = typeColors[a.type] || typeColors.general;
        return (
          <div key={a.id} style={styles.card}>
            <div style={styles.cardHeader}>
              <div style={styles.leftSide}>
                <span style={styles.typeIcon}>{typeInfo.icon}</span>
                <div>
                  <h4 style={styles.cardTitle}>{a.title}</h4>
                  <p style={styles.teacherName}>By: {a.teacher_name}</p>
                </div>
              </div>
              <div style={styles.rightSide}>
                <span style={{
                  ...styles.typeBadge,
                  background: typeInfo.bg,
                  color: typeInfo.color
                }}>
                  {a.type}
                </span>
                <p style={styles.date}>
                  {new Date(a.created_at).toLocaleDateString()}
                </p>
              </div>
            </div>
            <p style={styles.content}>{a.content}</p>
          </div>
        );
      })}
    </div>
  );
};

const styles = {
  title: { color: '#1a3a5c', marginBottom: '20px' },
  empty: { textAlign: 'center', color: '#999', padding: '40px', background: 'white', borderRadius: '12px' },
  card: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', borderLeft: '4px solid #0d6efd' },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' },
  leftSide: { display: 'flex', gap: '12px', alignItems: 'flex-start' },
  typeIcon: { fontSize: '24px' },
  cardTitle: { color: '#1a3a5c', margin: '0 0 4px', fontSize: '16px' },
  teacherName: { color: '#666', fontSize: '13px', margin: 0 },
  rightSide: { textAlign: 'right' },
  typeBadge: { padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' },
  date: { color: '#999', fontSize: '12px', margin: '5px 0 0' },
  content: { color: '#555', fontSize: '14px', lineHeight: '1.6', margin: 0 },
};

export default StudentAnnouncements;